import {inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {MessengerFlags} from './messenger-flags';
import {MessengerPortBacklog, routedPort} from './messenger-port';
import {TypingMember} from './messenger.models';
import {MessengerSignalsReal} from './signals.real';
import {MessengerSignalsFixture} from './signals.fixture';

/**
 * THE SIGNALS PORT (ITP-E-194-02): the thread's signals beyond today's `readStatus` ticks: where unread starts,
 * delivery, and typing.
 */
@Injectable({
  providedIn: 'root',
  useFactory: () => routedPort<MessengerSignalsPort>(inject(MessengerSignalsReal), inject(MessengerSignalsFixture),
    MESSENGER_SIGNALS_BACKLOG, inject(MessengerFlags))
})
export abstract class MessengerSignalsPort {
  /** B-09: `firstUnreadSequence` on the conversation by id; null when everything is read. */
  abstract firstUnreadSequence(conversationId: string): Observable<number | null>;

  /** B-17: the sequence delivered to every member (`Delivered` in `ReadStatus`). */
  abstract deliveredUpTo(conversationId: string): Observable<number | null>;

  /** B-17: `DeliveredUpTo(conversationId, sequence)`. */
  abstract markDelivered(conversationId: string, sequence: number): Observable<void>;

  /** B-18: the `ConversationTyping` events on the members' channels, as who is typing now. */
  abstract typing(conversationId: string): Observable<TypingMember[]>;

  /** B-18: `SetTypingCommand`, at most once per 3 s. */
  abstract setTyping(conversationId: string): Observable<void>;
}

export const MESSENGER_SIGNALS_BACKLOG: MessengerPortBacklog<MessengerSignalsPort> = {
  firstUnreadSequence: 'B-09',
  deliveredUpTo: 'B-17',
  markDelivered: 'B-17',
  typing: 'B-18',
  setTyping: 'B-18'
};
